import styled from "styled-components";
export const MobileHeaderContainer = styled.div`
  height: 1rem;
  display: flex;
  align-items: center;
  line-height: 1.5rem;
  font-size: 1rem;
  text-align: left;
`;

export const HeaderTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 100%;
  padding: 0 0.5rem;
  padding-top: 0.22rem;
`;
